var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0731 6.10399L18.2551 10.0668L17.1391 10.4164V13.9712L9.17672 16.4992L2.99552 13.8372V10.5332L1.74512 9.99639L3.10512 5.95639L10.9755 3.50159L17.0731 6.10399ZM10.2747 8.99639L11.1015 11.2584L17.0151 9.40679L16.3263 7.10039L10.2747 8.99639ZM15.2167 6.39999L11.4471 4.79039V7.58119L15.2167 6.39999ZM9.25112 8.26919L10.4471 7.89439V4.71399L4.94232 6.43119L9.25112 8.26919ZM8.18192 8.89959L3.80032 7.03079L2.98752 9.43999L7.27712 11.28L8.18192 8.89959ZM7.84032 12.612L3.99592 10.96V13.1784L8.72272 15.2144V10.2856L7.84032 12.612ZM9.72432 15.2752L16.1395 13.2364V10.7296L10.4899 12.4984L9.72432 10.4036V15.2752Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResources);
export default __webpack_public_path__ + "static/media/icon-resources.b0cd0da52e46e240e4d90ef18da1ff33.svg";
export { ForwardRef as ReactComponent };